import { render, staticRenderFns } from "./OrgNotification.vue?vue&type=template&id=7915c026&"
import script from "./OrgNotification.vue?vue&type=script&lang=js&"
export * from "./OrgNotification.vue?vue&type=script&lang=js&"
import style0 from "./OrgNotification.vue?vue&type=style&index=0&id=7915c026&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports